<template>
  <div class="container">
    <div class="p-grid">
      <template
        v-if="
          sessionState.profile.lineRegisterLink.startsWith('https') === true &&
            sessionState.profile.isLineLinked !== true
        "
      >
        <div class="p-col-12">
          <Message severity="error">
            <span
              >คุณยังไม่ได้เชื่อมต่อกับระบบ Line กรุณาเชื่อมต่อเพื่อรับ
              การแจ้งเตือนจากเรา
            </span>
          </Message>
        </div>
        <div class="p-col-12">
          <Button
            icon="pi pi-external-link"
            label="กดที่นี้ เชื่อมต่อระบบ line"
            @click="onOpenRegisterLink"
          />
        </div>
      </template>
      <div class="p-col-12">
        <div class="p-panel">
          <div class="p-panel-content p-pt-5">
            <div class="p-grid">
              <div class="p-col-12 p-lg-4 p-md-6 p-mt-2">
                <span class="p-field-checkbox">
                  <Checkbox
                    id="showAllTraining"
                    v-model="showAll"
                    binary
                  ></Checkbox>
                  <label for="showAllTraining">แสดงทั้งหมด</label>
                </span>
              </div>
              <transition name="fade">
                <div
                  class="p-col-12 p-lg-4 p-md-6 p-fluid"
                  v-if="showAll === true"
                >
                  <span class="p-float-label">
                    <Dropdown
                      v-model="numberOfDays"
                      :options="dayOptions"
                      optionLabel="description"
                      optionValue="code"
                      id="days"
                    ></Dropdown>
                    <label for="days">กรองข้อมูลตามวันที่</label>
                  </span>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="p-col-12">
        <div class="p-panel">
          <div class="p-panel-header">
            <div class="p-panel-title">เอกสารการฝึกอบรม</div>
          </div>
          <div class="p-panel-content">
            <div class="p-grid">
              <div class="p-col-12">
                <DataTable
                  :value="trainingDocuments"
                  class="p-datatable-sm"
                  paginator
                  :rows="10"
                >
                  <template #empty="">ไม่พบเอกสาร</template>
                  <Column
                    header="รหัส Course"
                    field="trainingDocument.id"
                  ></Column>
                  <Column
                    header="ชื่อ Course"
                    field="trainingDocument.course.description"
                  ></Column>
                  <Column
                    header="วันที่เริ่มต้น"
                    field="trainingDocument.startDate"
                  >
                    <template #body="props">
                      {{ formatAppDate(props.data.trainingDocument.startDate) }}
                    </template>
                  </Column>
                  <Column
                    header="วันที่สิ้นสุด"
                    field="trainingDocument.endDate"
                  >
                    <template #body="props">
                      {{ formatAppDate(props.data.trainingDocument.endDate) }}
                    </template>
                  </Column>
                  <Column headerStyle="width:4rem" bodyStyle="width:4rem">
                    <template #body="props">
                      <Button
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-success"
                        @click="
                          () => onGoAssessment(props.data.trainingDocument.id)
                        "
                        v-if="props.data.employeeId === username"
                      ></Button>
                      <Button
                        class="p-button-rounded p-button-success"
                        icon="pi pi-star"
                        @click="
                          () =>
                            onGoSupervisorAssessment(
                              props.data.trainingDocument.id,
                              props.data.employeeId
                            )
                        "
                        v-if="props.data.employeeId !== username"
                      ></Button> </template
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="p-col-12">
        <div class="p-panel">
          <div class="p-panel-header">
            <div class="p-panel-title">เอกสารการฝึกอบรม</div>
          </div>
          <div class="p-panel-content">
            <div class="p-grid">
              <div class="p-col-12">
                <DataTable
                  :value="assessmentDocuments"
                  class="p-datatable-sm"
                  paginator
                  :rows="10"
                >
                  <template #empty="">ไม่พบเอกสาร</template>

                  <Column
                    header="หัวข้อแบบประเมิน"
                    field="question.name"
                    sortable
                  ></Column>
                  <Column
                    header="รหัสการอบรม"
                    field="trainingAttendance.trainingDocument.id"
                    sortable
                  ></Column>
                  <Column
                    header="ชื่อการอบรม"
                    field="trainingAttendance.trainingDocument.course.description"
                    sortable
                  ></Column>
                  <Column
                    header="วันที่"
                    field="trainingAttendance.trainingDocument.startDate"
                    sortable
                  >
                    <template #body="props">
                      {{
                        `${formatAppDate(
                          props.data.trainingAttendance.trainingDocument
                            .startDate
                        )} - ${formatAppDate(
                          props.data.trainingAttendance.trainingDocument.endDate
                        )}`
                      }}
                    </template>
                  </Column>
                  <Column header="พนักงาน">
                    <template #body="props">
                      {{ props.data.employee.id }} :
                      {{ props.data.employee.prename
                      }}{{ props.data.employee.name }}
                      {{ props.data.employee.surname }}
                    </template>
                  </Column>
                  <Column header="สถานะ" field="status" sortable>
                    <template #body="props">
                      <StatusBadge
                        :badgeOnly="true"
                        :status="props.data.status"
                      ></StatusBadge>
                    </template>
                  </Column>
                  <Column headerStyle="width:4rem" bodyStyle="width:4rem">
                    <template #body="props">
                      <Button
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-success"
                        @click="
                          () =>
                            onAssessment(
                              props.data.trainingAttendance.trainingDocument.id,
                              props.data.questionId
                            )
                        "
                        v-if="props.data.employeeId === username"
                      ></Button>
                      <Button
                        class="p-button-rounded p-button-success"
                        icon="pi pi-star"
                        @click="
                          () =>
                            onSupervisorAssessment(
                              props.data.trainingAttendance.trainingDocument.id,
                              props.data.questionId,
                              props.data.employeeId
                            )
                        "
                        v-if="props.data.employeeId !== username"
                      ></Button> </template
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-col-12">
        <div class="p-panel">
          <div class="p-panel-header">
            <div class="p-panel-title">
              เอกสารพนักงานใหม่/โอนย้าย/เลื่อนตำแหน่ง
            </div>
          </div>
          <div class="p-panel-content">
            <div class="p-grid">
              <div class="p-col-12">
                <DataTable
                  :value="positionDocuments"
                  class="p-datatable-sm"
                  paginator
                  :rows="10"
                >
                  <template #empty="">ไม่พบเอกสาร</template>
                  <Column header="รหัสเอกสาร" field="id" sortable></Column>
                  <Column header="วันที่เอกสาร" field="documentDate" sortable>
                    <template #body="props">
                      {{ formatAppDate(props.data.documentDate) }}
                    </template>
                  </Column>
                  <Column header="พนักงาน">
                    <template #body="props">
                      {{ props.data.employee.id }} :
                      {{ props.data.employee.prename
                      }}{{ props.data.employee.name }}
                      {{ props.data.employee.surname }}
                    </template>
                  </Column>
                  <Column header="สถานะ" field="status" sortable>
                    <template #body="props">
                      <StatusBadge
                        :badgeOnly="true"
                        :status="props.data.status"
                      ></StatusBadge>
                    </template>
                  </Column>
                  <Column headerStyle="width:4rem" bodyStyle="width:4rem">
                    <template #body="props">
                      <Button
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-success"
                        @click="onPositionAssessment(props.data.id)"
                      ></Button> </template
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="p-lg-6">
        <div class="p-panel">
          <div class="p-panel-header">
            <div class="p-panel-title">
              เอกสาร Competency
            </div>
          </div>
          <div class="p-panel-content">
            <div class="p-grid">
              <div class="p-col-12">
                <DataTable
                  :value="[]"
                  class="p-datatable-sm"
                  paginator
                  :rows="10"
                >
                  <template #empty="">ไม่พบเอกสาร</template>
                  <Column header="รหัสเอกสาร" field="id"></Column>
                  <Column header="ชื่อพนักงาน"></Column>
                  <Column header="วันที่เอกสาร"></Column>
                  <Column>
                    <template #body> <Button></Button> </template
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import { usePlugin } from "@/plugins";
import {
  GetWorklistRequest,
  GetWorklistResponse,
  TrainingAttendance,
  PositionDocument,
  TrainingAssessment,
} from "@/types";
import { Dictionary } from "vue-gtag-next";
import { useLocalStorage } from "@vueuse/core";
import StatusBadge from "@/components/StatusBadge.vue";
// import SubmitApprovePanel from "@/components/SubmitApprovePanel.vue";

export default defineComponent({
  name: "Home",
  components: { StatusBadge },
  setup() {
    const {
      axios,
      error,
      success,
      setLoading,
      formatAppDate,
      router,
      useState,
      useSessionState,
    } = usePlugin();
    const showAll = useLocalStorage("Home_showAll", false);
    const dayOptions = [
      { code: 30, description: "30 วันย้อนหลัง" },
      { code: 60, description: "60 วันย้อนหลัง" },
      { code: 90, description: "90 วันย้อนหลัง" },
      { code: -1, description: "ทั้งหมด" },
    ];
    const numberOfDays = useLocalStorage("Home_numberOfDays", 30);

    // const trainingDocuments = ref<TrainingAttendance[]>([]);
    const positionDocuments = ref<PositionDocument[]>([]);
    const assessmentDocuments = ref<TrainingAssessment[]>([]);

    const loadDocuments = async () => {
      setLoading(true);
      try {
        var result = await axios.post<GetWorklistResponse>(
          "api/v1/services/worklist",
          {
            showAll: showAll.value,
            numberOfDays: numberOfDays.value,
          } as GetWorklistRequest
        );
        // trainingDocuments.value = result.data.trainingDocuments ?? [];
        positionDocuments.value = result.data.positionDocuments ?? [];
        assessmentDocuments.value = result.data.trainingAssessments ?? [];
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onGoAssessment = (documentId: string) => {
      router.push({
        name: "performTrainingAssessment",
        params: {
          documentId: documentId,
        },
      });
    };
    const onAssessment = (documentId: string, questionId: number) => {
      router.push({
        name: "performAssessment",
        params: {
          documentId: documentId,
          questionId: questionId,
        },
      });
    };
    const onSupervisorAssessment = (
      documentId: string,
      questionId: number,
      employeeId: string
    ) => {
      router.push({
        name: "viewAssessment",
        params: {
          documentId: documentId,
          questionId: questionId,
          employeeId: employeeId,
        },
      });
    };
    const onGoSupervisorAssessment = (
      documentId: string,
      employeeId: string
    ) => {
      router.push({
        name: "viewTrainingAssessment",
        params: {
          documentId: documentId,
          employeeId: employeeId,
        },
      });
    };

    const onPositionAssessment = (documentId: string) => {
      router.push({ name: "positionAssessment", params: { id: documentId } });
    };
    // const trainingDocumentsStatus = computed(() => {
    //   var result: Dictionary<{ status: string; severity: string }> = {};
    //   trainingDocuments.value.map((x) => {
    //     const key = `${x.trainingDocumentId}${x.employeeId}`;
    //     let status = "TBD";
    //     // x.approveOn !== null
    //     //   ? "อนุมัติแล้ว"
    //     //   : x.submitOn != null
    //     //   ? "ส่งเอกสารแล้ว"
    //     //   : "บันทึก";
    //     let severity = "info";
    //     // x.approveOn !== null
    //     //   ? "success"
    //     //   : x.submitOn != null
    //     //   ? "warning"
    //     //   : "info";
    //     result[key] = {
    //       status: status,
    //       severity: severity,
    //     };
    //   });
    //   return result;
    // });
    const state = useState();
    const sessionState = useSessionState();

    const username = computed(() => state.value.authentication.username);
    const onOpenRegisterLink = () => {
      window.location.href = sessionState.value.profile.lineRegisterLink;
    };

    onMounted(() => loadDocuments());
    watch(
      () => showAll.value,
      () => loadDocuments()
    );
    watch(
      () => numberOfDays.value,
      () => loadDocuments()
    );

    return {
      // onDownloadPDF,
      showAll,
      // trainingDocuments,
      // trainingDocumentsStatus,
      positionDocuments,
      assessmentDocuments,
      formatAppDate,
      onGoAssessment,
      onGoSupervisorAssessment,
      onAssessment,
      onSupervisorAssessment,
      onPositionAssessment,
      username,
      dayOptions,
      numberOfDays,
      state,
      sessionState,
      onOpenRegisterLink,
    };
  },
});
</script>

<style></style>
